import React from "react";
import Card from "react-bootstrap/Card";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { Col, Row } from "react-bootstrap";
import { images } from "../../../../constants";
import "./style.css";

// Updated JSON with full info
export const BusinessDatatwo = [
  {
    id: 1,
    title: "Available Jobs",
    info: (
      <>
        <p>
          This platform connects <strong>job seekers</strong> with companies
          looking for talent.
        </p>
        <p>
          To access this feature, users must complete their user profile and
          upload a full <strong>CV</strong>. Once the CV is filled in and
          published, it is automatically displayed in the{" "}
          <strong>Jobs Wanted</strong> section.
        </p>
        <p>
          Through this platform, companies can review user CVs directly and
          contact suitable candidates with job offers or interview
          opportunities.
        </p>
        <p>
          The <strong>Jobs Wanted</strong> feature increases visibility for job
          seekers and helps companies find the right candidates efficiently,
          creating a direct and transparent recruitment process.
        </p>
        <a href="https://www.youtube.com" target="_blank">
          <strong>Click here to see how to Explore the Jobs</strong>
        </a>
      </>
    ),
    para: "Find jobs and get noticed",
  },
  {
    id: 2,
    title: "Job Seekers",
    info: (
      <>
        <p>
          <strong>Job Posted</strong> is a section where companies advertise
          available job opportunities for required candidates.
        </p>
        <p>
          In this area, companies can post job advertisements detailing roles,
          requirements, and qualifications. Job seekers can visit this platform
          to view daily job postings from different companies and apply for
          positions that match their skills and experience.
        </p>
        <p>
          The <strong>Job Posted</strong> feature creates a direct connection
          between employers and job seekers, making recruitment efficient,
          transparent, and accessible.
        </p>
        <a href="https://www.youtube.com" target="_blank">
          <strong>Click here to see how to Explore the Candidates</strong>
        </a>
      </>
    ),
    para: "Post jobs and find candidates",
  },
];

const JobOppurtunity = ({ btn, titleone, titletwo }) => {
  return (
    <div>
      <Row>
        {BusinessDatatwo.map((data) => (
          <Col key={data.id} lg="6" md="6" sm="6" xs="6">
            {/* CardNav shows title + step-by-step info */}
            <CardNav
              Header={data.title}
              para={data.para}
              myinfo={data.info}
              myid={data.id}
            />

            <Card className="shadow-joboprt mt-2">
              {data.id === 1 ? (
                <BoxData
                  Title={titleone}
                  Butonn={btn}
                  imgg={images.Jobs}
                  ms="nine-element"
                  buy="nine"
                  url="/company-form"
                  link="/find-job"
                />
              ) : (
                <BoxData
                  Title={titletwo}
                  Butonn={btn}
                  imgg={images.Candidates}
                  link="/find-candidates"
                  ms="ten-element"
                  buy="ten"
                />
              )}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default JobOppurtunity;
